import { observer } from 'mobx-react';
import { FC, ReactElement } from 'react';
import EditFAQSort from '../../components/EditFAQSort/EditFAQSort';
import Text from '~/view/components/Text/Text';

const EditFAQDetailsBlock: FC = observer((): ReactElement => {
  return (
    <div className="d-flex flex-column">
      <Text type="section-header" text="txt_details" className="mb-4" />

      <EditFAQSort />
    </div>
  );
});

export default EditFAQDetailsBlock;
